
import enTranslations from './en';
import plTranslations from './pl';

export type Language = 'pl' | 'en';

export const translations: Record<Language, Record<string, any>> = {
  en: enTranslations,
  pl: plTranslations
};

export { enTranslations, plTranslations };
